import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';

export const Search = ({
  inputSearch,
  setInputSearch,
}: {
  inputSearch: string;
  setInputSearch: (inputSearch: string) => void;
}): JSX.Element => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newSearchValue: string = event.target.value;
    setInputSearch(newSearchValue);
  };

  return (
    <InputGroup size="sm" data-selector="filter-setup-search">
      <InputLeftElement pointerEvents="none">
        <FontAwesomeIcon icon={faSearch} />
      </InputLeftElement>
      <Input type="search" aria-label="Search" placeholder="Search" value={inputSearch} onChange={onChange} />
    </InputGroup>
  );
};
